import React from 'react'

const SvgBin = props => (
    <svg width="1em" height="1em" viewBox="0 0 15 18" {...props}>
        <path d="M1.891 18l-.043-.765-.59-11.782H2.8l.55 10.93h8.303l.536-10.93h1.553L13.125 18H1.891zm8.882-18v2.022H15V3.64H0V2.022h4.227V0h6.546zM5.574 2.022h3.852v-1.01H5.574v1.01zm.997 13.042l-.196-9.61h-1.34l.196 9.61h1.34zm3.176 0l.196-9.61h-1.34l-.195 9.61h1.34z" />
    </svg>
)

export default SvgBin
